import { render, staticRenderFns } from "./HtmlToImageForPdf.vue?vue&type=template&id=2cc9ea62&scoped=true&"
import script from "./HtmlToImageForPdf.vue?vue&type=script&lang=js&"
export * from "./HtmlToImageForPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9ea62",
  null
  
)

export default component.exports